{
  "R": [0, 255, 255],
  "G": [72, 88, 255],
  "B": [0, 0, 0],
  "A": [0, 64, 128],
  "I": [0, 88, 255]
}
